<div class="card shadow-sm">
  <div
    class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
  >
    <h5 class="mb-0">Enterprises</h5>

    <!-- Search Box -->
    <div class="d-flex">
      <input
        type="text"
        class="form-control form-control-sm me-2"
        placeholder="Search enterprise..."
        [(ngModel)]="search"
        (keyup.enter)="onSearch()"
      />
      <button class="btn btn-sm btn-light" (click)="onSearch()">
        <i class="fa fa-search"></i>
      </button>
    </div>
  </div>

  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table table-bordered table-hover mb-0">
        <thead class="table-light">
          <tr>
            <th>Enterprise Name</th>
            <th>Company Code</th>
            <th>Email</th>
            <th>Phone</th>
            <th>City / State</th>
            <th>Enterprise Type</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let data of enterpriseList">
            <td class="fw-bold">{{ data.enterpriseName }}</td>
            <td>{{ data.companyCode }}</td>
            <td>{{ data.email }}</td>
            <td>{{ data.phone }}</td>
            <td>{{ data.city }}, {{ data.state }}</td>
            <td>
              <span class="badge bg-info">
                {{ data.enterpriseType }}
              </span>
            </td>

            <td class="text-center">
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="viewDashboard(data)"
              >
                <i class="fa fa-eye me-1"></i> View
              </button>
            </td>
          </tr>

          <tr *ngIf="enterpriseList?.length === 0">
            <td colspan="7" class="text-center text-danger py-3">
              Data not found
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="d-flex p-2">
      <ngb-pagination
        (pageChange)="gty((page = $event))"
        [collectionSize]="totalRecords"
        [(page)]="page"
        [pageSize]="limit"
        [maxSize]="3"
        [rotate]="true"
      >
      </ngb-pagination>
    </div>
  </div>
</div>
